<template>
  <v-main
    @drop.prevent
    class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0 im-checkout"
    style="height: 100%;"
  >
    <v-layout
      row
      class="my-10"
    >
      <v-flex
        md12
        sm12
      >
        <div class="ml-6">
          <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Checkout
          </div>

          <v-layout
            row
            py-10
            class="checkout_layout"
          >
            <v-flex
              md6
              sm12
            >
              <h3 class="text__colour-teal">Your Reference</h3>
              <!--<v-form ref="orderref" v-model="job" lazy-validation>-->
              <v-form
                ref="form"
                v-model="referenceValid"
              >
                <div class="layout__width-500px">
                  <v-text-field
                    :rules="rules.referenceRules"
                    v-model="orderReference"
                    ref="orderReference"
                    label="To help you locate your order faster enter a reference"
                    required
                  >
                  </v-text-field>
                </div>
              </v-form>

              <h3 class="text__colour-teal">Ravensworth job number</h3>

              <div class="layout__margin__bottom-20">
                <div>
                  {{ this.order.id }}
                </div>
              </div>

              <h3 class="text__colour-teal">Billing Address</h3>

              <div class="py-4 billing-address">
                <p
                  v-show="customer.address1"
                  class="pa-0 ma-0 pb-2"
                >
                  {{ customer.address1 }}
                </p>
                <p
                  v-show="customer.address2"
                  class="pa-0 ma-0 pb-2"
                >
                  {{ customer.address2 }}
                </p>
                <p
                  v-show="customer.address3"
                  class="pa-0 ma-0 pb-2"
                >
                  {{ customer.address3 }}
                </p>
                <p
                  v-show="customer.town"
                  class="pa-0 ma-0 pb-2"
                >
                  {{ customer.town }}
                </p>
                <p
                  v-show="customer.county"
                  class="pa-0 ma-0 pb-2"
                >
                  {{ customer.county }}
                </p>
                <p
                  v-show="customer.postcode"
                  class="pa-0 ma-0 pb-2"
                >
                  {{ customer.postcode }}
                </p>
              </div>

              <h3 class="text__colour-teal">Order Summary</h3>

              <div>
                <!-- TODO: get template type from session / cookie -->

                <div>
                  Direct Mail template<br>
                  Price includes data charge, print and postage
                </div>
                <div>
                  {{ this.quantity }} x records ({{ this.pricePerItem }} each): {{ this.netTotalPrice }}
                </div>
                <div class="layout__margin__bottom-50">
                  VAT: {{ this.vatTotalPrice }}
                </div>
                <div class="layout__width-100 text__colour-teal text__size-22 text__style-bold layout__margin__bottom-50">
                  Total: {{ this.grossTotalPrice }}
                </div>

                <div
                  v-if="paygDirectMailrExtraCharge"
                  class="layout__width-100 text__align-center text__colour-red"
                >
                  * An additional fee will be collected in case of payment by a credit card - &pound;{{ paygDirectMailrExtraCharge }} + VAT
                </div>
              </div>
            </v-flex>

            <v-flex
              md6
              sm12
            >
              <main class="main">
                <div class="main__section main__section-iframe">
                  <div class="main__iframe layout__width-height-0 layout__left-50 layout__top-50px">
                    <iframe id="editorFrame"></iframe>
                  </div>
                </div>
                <div class="main__section main__section-iframe">
                  <div
                    class="main__preview__iframe"
                    id="previewFrame"
                  ></div>
                </div>
              </main>

              <div
                class="main__iframe masked-element-preview"
                id="loaderDiv"
              >
                <div class="mask">
                  <div class="loader-wrapper icon-cc-logo">
                    <div class="loader"></div>
                  </div>
                  <div class="masked-element-message">
                  </div>
                </div>
              </div>
            </v-flex>

            <v-flex
              md4
              class="text-left"
            >
              <el-button
                class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                @click="goBack()"
              >Back
              </el-button>
            </v-flex>

            <v-flex
              md4
              class="text-center"
            >
              <el-button
                v-if="isAccount"
                class="button__base layout__width-200px button__background-red layout__cursor-pointer"
                :disabled="(this.orderReference === '') || isOrderReady"
                @click="showConfirmPopup()"
              >
                Continue with account
              </el-button>
            </v-flex>

            <!--<v-flex
              md4
              class="text-right"
            >
              <el-button
                class="button__base layout__width-200px button__background-red layout__cursor-pointer"
                :disabled="(this.orderReference === '') || isOrderReady"
                @click="activateCheckout = true"
              >
                Continue with card
              </el-button>
            </v-flex>-->
          </v-layout>

          <div
            class="layout__padding-clear"
            v-show="showConfirmation"
          >
            <el-dialog
              :visible.sync="showConfirmation"
              :close-on-press-escape="false"
              :close-on-click-modal="false"
              width="500px"
            >
              <div class="text__size-22 text__align-center text__colour-teal layout__margin__bottom-20 text__style-bold">
                Would you like to proceed with your order?
              </div>
              <div class="text__size-16 text__align-center layout__margin__top-20 layout__margin__bottom-20 text__line-height-12">
                By clicking "Confirm Order" you are<br>approving your artwork, agreeing to<br>pay
                {{ this.grossTotalPrice }} and accepting our terms<br>and conditions.<br><br>
                Delivery of your direct mail campaign<br>will be made within 5 working days.<br><br>
                If you have any questions about your<br>order, please contact our customer<br>service team<br><br>
                <div class="text__colour-teal">
                  01865 712211<br>orders@printconcern.co.uk
                </div>
              </div>

              <div class="text__align-center layout__margin__top-50 layout__margin__left-50 layout__margin__right-50">
                <el-button
                  class="button__base layout__width-150px button-teal layout__cursor-pointer layout__float-left layout__margin__top-minus-20"
                  @click="showConfirmation = false"
                >Back
                </el-button>
                <el-button
                  :disabled="isOrderReady"
                  class="button__background-red button__base layout__width-150px layout__cursor-pointer layout__float-right layout__margin__top-minus-20"
                  @click="confirm()"
                >Confirm Order
                </el-button>
              </div>

              <div class="text__size-12 text__align-center layout__padding__top-40px layout__margin__bottom-20 text__line-height-12">
                Invoices are issued at the beginning of the month.<br>Payment terms are 30 days.<br>
                Ravensworth <a
                href="https://ravensworth.co.uk/terms-and-conditions/"
                target="new"
                class="ts-and-cs-link"
              >Terms and Conditions</a>
              </div>

            </el-dialog>
          </div>

          <v-snackbar
            v-model="confirmOrderFailure"
            color="error"
            :top="true"
            :timeout="5000"
          >
            <div>
              Sorry there has been a problem confirming your order. Please try again.
            </div>
            <div v-if="confirmOrderFailureData">
              <div>
                {{ confirmOrderFailureData.errorMessage }}
              </div>
              <div>
                The following parameters are missing:
              </div>
              <div
                v-if="confirmOrderFailureData.memberNames && confirmOrderFailureData.memberNames.length"
                v-for="memberName in confirmOrderFailureData.memberNames"
                :key="memberName"
              >
                {{ memberName }}
              </div>
            </div>
            <v-btn
              dark
              text
              @click="confirmOrderFailure = false"
            >
              Close
            </v-btn>
          </v-snackbar>

          <v-overlay :value="loading">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>

          <el-dialog
            id="checkoutDialog"
            :visible.sync="activateCheckout"
            width="350px"
            class="rounded"
            @opened="openCheckout()"
            @closed="onClosed"
          >
            <div
              slot="title"
              class="checkoutTitle"
            >
              <img
                class="checkoutPhotofixrLogo"
                src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/basicIcon.png"
              >
              <div class="checkoutHeaderLine1">Directmailr Payment</div>
              <br>
              <div class="checkoutHeaderLine2">Complete transaction of {{ grossTotalPriceWithCharge }}</div>
            </div>
            <form
              id="payment-form"
              method="POST"
              action="https://merchant.com/charge-card"
            >
              <div class="custom-label">
                <label for="card-number">Card number</label>
              </div>
              <div class="input-container card-number">
                <div class="icon-container">
                  <img
                    id="icon-card-number"
                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/card.svg"
                    alt="PAN"
                  />
                </div>
                <div class="card-number-frame"></div>
                <div class="icon-container payment-method">
                  <img id="logo-payment-method" />
                </div>
                <div class="icon-container">
                  <img
                    id="icon-card-number-error"
                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
                  />
                </div>
              </div>
              <div class="date-and-code">
                <div>
                  <div class="custom-label">
                    <label for="expiry-date">Expiry date</label>
                  </div>
                  <div class="input-container expiry-date">
                    <div class="icon-container">
                      <img
                        id="icon-expiry-date"
                        src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/exp-date.svg"
                        alt="Expiry date"
                      />
                    </div>
                    <div class="expiry-date-frame"></div>
                    <div class="icon-container">
                      <img
                        id="icon-expiry-date-error"
                        src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div class="custom-label">
                    <label for="cvv">Security code</label>
                  </div>
                  <div class="input-container cvv">
                    <div class="icon-container">
                      <img
                        id="icon-cvv"
                        src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/cvv.svg"
                        alt="CVV"
                      />
                    </div>
                    <div class="cvv-frame"></div>
                    <div class="icon-container">
                      <img
                        id="icon-cvv-error"
                        src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <button
                id="pay-button"
                disabled=""
              >
                Pay with Card {{ grossTotalPriceWithCharge }}
              </button>
              <div>
                <span class="error-message error-message__card-number"></span>
                <span class="error-message error-message__expiry-date"></span>
                <span class="error-message error-message__cvv"></span>
              </div>
              <p class="payment-error-message"></p>
              <p class="success-payment-message"></p>
            </form>
          </el-dialog>

          <el-dialog
            :visible.sync="paymentErrorDialog"
            width="500px"
            class="rounded"
          >
            <div class="layout__position-center text__align-center">
              <h3 class="text__colour-teal layout__padding-20-0">Error completing transaction</h3>
              <p class="text__size-16">{{ this.paymentErrorMessage }}</p>

              <div class="layout__padding-20-0">
                <p>Please contact our Ravensworth Client Services team </p>
                <p>01865 712211</p>
                <p>orders@printconcern.co.uk</p>
              </div>
            </div>

            <div class="layout__padding-20-0 text__align-center">
              <el-button
                class="button-teal button__base layout__width-150px text__align-center"
                type="primary"
                @click="paymentErrorDialog = false"
              >Ok
              </el-button>
            </div>
          </el-dialog>
        </div>

      </v-flex>
    </v-layout>
  </v-main>
</template>

<script>
import Router from '../../router.js';
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import Editor from '../../mixins/Editor.js';

export default {
  name: 'InstantMarketingCheckout',

  VAT: 20,

  components: {},
  mixins: [axios],
  data: () => ({
    job: {},
    order: {},
    data_url: '',
    query_string: '',
    //formValid: false,
    referenceValid: true,
    cardValid: false,
    cardRequired: false,
    loading: false,
    orderReference: '',
    dataRef: '',
    //voucher: '',
    name: '',
    description: '',
    pageWidth: 0,
    pageHeight: 0,
    preferences: {},
    customer: {},
    user: {},
    template: {},
    product: {},
    config: {},
    editor: null,
    data: [],
    addresses: [],
    qs: '',
    excludes: [],
    imageUrl: '',
    proofImageUrls: [],
    imageUrlThumbs: [],
    addressTo: {},
    products: {},
    paymentMethod: 'account',
    canvasAuthToken: '',
    //vatTotalPrice: '£0.00',
    elements: '',
    isAccount: false,
    card: '',
    lazy: false,
    //voucherSuccess: '',
    //voucherFailure: '',
    showConfirmation: false,
    confirmationChecked: false,
    confirmOrderFailure: false,
    confirmOrderFailureData: false,
    customersCanvasApiKey: `${process.env.VUE_APP_CUSTOMERS_CANVAS_API_KEY}`,
    rules: {
      /*referenceRules: [
          v => !!v || 'Order Reference is required',
      ],*/
      referenceRules: [
        v => !! v || 'Please enter an order reference before continuing to review and place your order',
      ],
    },

    // checkout
    activateCheckout: false,
    paymentErrorDialog: false,
    token: '',
    paymentErrorMessage: '',

    paygDirectMailrExtraCharge: 0,
  }),
  computed: {
    quantity() {
      if (typeof this.order.printJobSpec === 'undefined') {
        return '0';
      } else {
        return this.order.printJobSpec.quantity.toString();
      }
    },
    pricePerItem() {
      if (typeof this.order.netTotalPrice === 'undefined' || typeof this.order.printJobSpec === 'undefined') {
        return '£0.00';
      } else {
        return '£' + (this.order.netTotalPrice / this.order.printJobSpec.quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    netUnitPrice() {
      if (typeof this.order.netUnitPrice === 'undefined') {
        return '£0.00';
      } else {
        return '£' + this.order.netUnitPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    netTotalPrice() {
      if (typeof this.order.netTotalPrice === 'undefined') {
        return '£0.00';
      } else {
        return '£' + this.order.netTotalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    vatTotalPrice() {
      if (typeof this.order.vatTotalPrice === 'undefined') {
        return '£0.00';
      } else {
        return '£' + this.order.vatTotalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    grossTotalPrice() {
      if (typeof this.order.grossTotalPrice === 'undefined') {
        return '£0.00';
      } else {
        return '£' + this.order.grossTotalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    formValid() {
      if (this.referenceValid == true && ((this.paymentMethod == 'online' && this.cardValid == true) || this.paymentMethod == 'account')) {
        return true;
      } else {
        return false;
      }
    },
    isOrderReady() {
      return (this.order.grossTotalPrice <= 0)
        || this.loading
        || ! this.order.branchId
        || ! (this.order.printJobSpec && this.order.printJobSpec.stockType)
        || ! (this.order.printJobSpec && this.order.printJobSpec.fCode)
        || ! (this.order.printJobSpec && this.order.printJobSpec.stockWeight);
    },

    paygDirectMailrExtraChargeWithVat() {
      return this.paygDirectMailrExtraCharge + ((this.paygDirectMailrExtraCharge / 100) * this.$options.VAT);
    },

    grossTotalPriceWithCharge() {
      if (typeof this.order.grossTotalPrice === 'undefined') {
        return '£0.00';
      } else {
        return '£' + (this.order.grossTotalPrice + this.paygDirectMailrExtraChargeWithVat).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
  },
  created() {
    this.preferences = JSON.parse(window.sessionStorage.getItem('_preferences'));
    this.customer = JSON.parse(window.sessionStorage.getItem('customer'));
    this.isAccount = this.customer && this.customer.accountType === 'ACCOUNT';
    this.user = JSON.parse(window.sessionStorage.getItem('user'));
    this.template = JSON.parse(window.sessionStorage.getItem('_template'));
    // this.qs = window.sessionStorage.getItem('qs');
    this.imageUrl = window.sessionStorage.getItem('imageUrl');
    this.addressTo = JSON.parse(window.sessionStorage.getItem('_addressTo'));

    const getOrderById = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

    console.log(getOrderById);

    this.paygDirectMailrExtraCharge = window.sessionStorage.getItem('_paygDirectMailrExtraCharge')
      ? Number(window.sessionStorage.getItem('_paygDirectMailrExtraCharge'))
      : 0;

    Axios.get(getOrderById, this.returnHeaderUsingToken())
      .then(response => {
        console.log(response.data);

        this.order = response.data[0];

        if (this.order.dataExclusions !== null) {
          this.order.dataExclusions.split(',').forEach(dataExclusion => {
            this.excludes.push(dataExclusion);
          });
        }

        console.log(JSON.stringify(this.excludes));

        console.log('quantity=' + this.quantity);
        console.log('pricePerItem=' + this.pricePerItem);
        console.log('netUnitPrice=' + this.netUnitPrice);
        console.log('netTotalPrice=' + this.netTotalPrice);
        console.log('vatTotalPrice=' + this.vatTotalPrice);
        console.log('grossTotalPrice=' + this.grossTotalPrice);

        var _this = this;

        if (document.getElementById('CcIframeApiScript')) {
          var element = document.getElementById('CcIframeApiScript');
          element.parentNode.removeChild(element);
        }

        if (! document.getElementById('CcIframeApiScript')) {
          let recaptchaScript = document.createElement('script');
          recaptchaScript.onload = async function () {
            let productThemes = {};

            var customer = JSON.parse(window.sessionStorage.getItem('customer')),
              user = JSON.parse(window.sessionStorage.getItem('user')),
              template = JSON.parse(window.sessionStorage.getItem('_template')),
              mockupFile = window.sessionStorage.getItem('_mockupFile'),
              templatingValues = {};

            if (window.sessionStorage.getItem('templatingValues') !== 'undefined') {
              templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));
            } else {
              templatingValues = {
                'varCompany_Colour_1': '',
                'varCompany_Colour_2': '',
                'varCompany_Colour_3': '',
                'varUser_Company_Name': '',
                'varUser_Company_Brand': '',
                'varUser_Address_1': '',
                'varUser_Address_2': '',
                'varUser_Town': '',
                'varUser_County': '',
                'varUser_PostCode': '',
                'varUser_FullAddress': '',
                'varUser_Branch_Name': '',
                'varUser_Telephone': '',
                'varUser_Email': '',
                'varUser_Web_Address': '',
                'varCompany_Logo_1': null,
                'varCompany_Logo_2': null,
                'varCompany_Logo_3': null,
                'varCompany_Logo_4': null,
              };
            }

            // console.log('user=' + JSON.stringify(user));
            // console.log('templatingValues=' + JSON.stringify(templatingValues));

            // productThemes = {
            //     [customer.ref]: {
            //         "varCompany_Colour_1": templatingValues.varCompany_Colour_1,
            //         "varCompany_Colour_2": templatingValues.varCompany_Colour_2,
            //         "varCompany_Colour_3": templatingValues.varCompany_Colour_3
            //     }
            // }

            productThemes = {
              [customer.ref]: {
                'varCompany_Colour_1': '',
                'varCompany_Colour_2': '',
                'varCompany_Colour_3': ''
              }
            };

            console.log('productThemes=' + JSON.stringify(productThemes));

            if (customer.ref !== null) {
              var endpoint = `https://cc.ravensworth.uk/api/Auth/Users/` + customer.ref + '/Tokens?seconds=3600&updateOnCall=True';
              console.log(endpoint);

              await Axios({
                method: 'post',
                url: endpoint,
                headers: { 'X-CustomersCanvasAPIKey': _this.customersCanvasApiKey }
              })
                .then(response => {
                  console.log(response);

                  this.canvasAuthToken = response.data.tokenId;
                })
                .catch(error => {
                  console.log(error);
                });

              console.log('_this.data=' + JSON.stringify(_this.data));

              this.product = {
                'surfaces': {
                  'file': template.name,
                  'name': 'Page {0}'
                }
              };

              this.config = {
                'tokenId': this.canvasAuthToken,
                'autoLoadUserInfo': true,
                'initialMode': 'SimpleOnly',
                'customerRef': customer.ref,
                'organisationId': 1,
                'violationWarningsSettings': {
                  'regionViolationWarningEnabled': false,
                  'safetyLineViolationWarningEnabled': false
                },
                'themeConfiguration': {
                  'primaryColor': '#007F8B',
                  'logo': 'data:image/svg+xml;base64,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'
                },
                // "watermark": {
                //     "image": {
                //         "name": "proof.png",
                //         "repeat": false,
                //         "opacity": 0.9
                //     },
                //     "visibility": {
                //         "proof": true,
                //         "canvas": false
                //     }
                // },
                'userInfo': {
                  // "varCompany_Logo_1": templatingValues.varCompany_Logo_1,
                  // "varCompany_Logo_2": templatingValues.varCompany_Logo_2,
                  // "varCompany_Logo_3": templatingValues.varCompany_Logo_3,
                  // "varCompany_Logo_4": templatingValues.varCompany_Logo_4,
                  // "varCompany_Colour_1": templatingValues.varCompany_Colour_1,
                  // "varCompany_Colour_2": templatingValues.varCompany_Colour_2,
                  // "varCompany_Colour_3": templatingValues.varCompany_Colour_3,
                  'varBranch_Company_Name': templatingValues.varUser_Company_Name,
                  'varBranch_Company_Brand': templatingValues.varUser_Company_Brand,
                  'varBranch_Name': templatingValues.varUser_Branch_Name,
                  'varBranch_Email': templatingValues.varUser_Email,
                  'varBranch_Telephone': templatingValues.varUser_Telephone,
                  'varBranch_Web_Address': templatingValues.varUser_Web_Address,
                  'varBranch_Address_1': templatingValues.varUser_Address_1,
                  'varBranch_Address_2': templatingValues.varUser_Address_2,
                  'varBranch_Address_3': templatingValues.varUser_Address_3,
                  'varBranch_Town': templatingValues.varUser_Town,
                  'varBranch_County': templatingValues.varUser_County,
                  'varBranch_PostCode': templatingValues.varUser_PostCode,
                  'varBranch_FullAddress': templatingValues.varUser_FullAddress,
                  'varUser_Firstname': templatingValues.varUser_Firstname,
                  'varUser_Surname': templatingValues.varUser_Surname,
                  'varUser_FullName': templatingValues.varUser_FullName,
                  'varUser_Email': templatingValues.varUser_Email,
                  'varUser_Telephone': templatingValues.varUser_Telephone,
                  'varUser_Staff_Image': templatingValues.varUser_Staff_Image,
                  'varUser_Job_Title': templatingValues.varUser_Job_Title,
                  'varUser_Mobile': templatingValues.varUser_Mobile,
                  'varUser_Info_1': templatingValues.varUser_Info_1,
                  'varUser_Info_2': templatingValues.varUser_Info_2,
                  'varUser_Info_3': templatingValues.varUser_Info_3,
                  'varUser_Info_4': templatingValues.varUser_Info_4,
                  'varUser_Info_5': templatingValues.varUser_Info_5,
                  'varUser_Info_6': templatingValues.varUser_Info_6
                },
                'widgets': {
                  'ObjectInspector': {
                    'isHidden': true,
                    'toggleEnabled': false
                  },
                  'ItemMenu': {
                    'objectManipulationEnabled': false,
                    'verticalAlignmentEnabled': false,
                    'horizontalAlignmentEnabled': false,
                    'changeZOrderEnabled': false
                  },
                  'TopToolbar': {
                    'historyButtonsEnabled': false,
                    'revertButtonEnabled': false,
                    'imageEditButtonEnabled': false,
                    'imageSelectButtonEnabled': false
                  },
                  'BottomToolbar': {
                    'zoomValueEnabled': true,
                    'zoomButtonsEnabled': true,
                    'fullWindowButtonEnabled': false,
                    'fullScreenButtonEnabled': false,
                    'safetyLinesCheckboxEnabled': false,
                    'gridCheckboxEnabled': false,
                    'snapLinesCheckboxEnabled': false,
                    'rotateButtonEnabled': false,
                    'surfaceSwitch': {
                      'enabled': true,
                      'showThumbnails': true,
                      'showSurfaceNames': true,
                      'scrollPageButtonsEnabled': true,
                      'toggleSurfaceButtonsEnabled': true,
                      'firstAndLastButtonsEnabled': true,
                      'specificForSurfaceCount': {
                        // Disable the navigation area for single-page products.
                        1: {
                          'enabled': false
                        },
                        // Enable only page names for two-page products.
                        2: {
                          'showSurfaceNames': true,
                          'showThumbnails': true,
                          'scrollPageButtonsEnabled': true,
                          'toggleSurfaceButtonsEnabled': true,
                          'firstAndLastButtonsEnabled': true
                        }
                      }
                    }
                  }
                },
                // "productThemes": productThemes,
                'defaultAssetSelectWidget': 'GalleryDialog',
                // "defaultProductTheme": customer.ref,
                'userId': customer.ref
              };

              console.log('this.config=' + JSON.stringify(this.config));

              // Customer's Canvas is loaded with this line. See the JSON objects above for params.

              if (window.sessionStorage.getItem('stateId') === null) {
                //this.editor = await _this.loadEditor(document.getElementById("editorFrame"), this.product, this.config, templatingValues);
                var templateSelected = template.url.replace('.st', '');
                this.editor = await _this.loadEditor(document.getElementById('editorFrame'), templateSelected, this.config, templatingValues);
                // this.editor.applyProductTheme(customer.ref);
              } else {
                var stateId = window.sessionStorage.getItem('stateId');
                console.log('stateId=' + stateId);
                this.editor = await _this.loadEditor(document.getElementById('editorFrame'), stateId, this.config, templatingValues);
                // this.editor.applyProductTheme(customer.ref);
              }

              Editor['data'].editor = this.editor;

              if (mockupFile !== null) {
                this.editor.getProduct()
                  // If we have successfully obtained the product.
                  .then(function (product) {
                    var surface = product.surfaces.length - 1;

                    product.setMockups([
                      {
                        'surface': product.surfaces[surface],
                        'mockup': { 'down': mockupFile },
                      }
                    ])
                      .then(function (product) {
                        console.log('Mockups are successfully set for the product ' + product.id);
                      })
                      .catch(function (error) {
                        console.error('Failed to set up the mockups: ', error);
                      });
                  });
              }

              this.editor.getProduct()
                // If we have successfully obtained the product.
                .then(function (product) {
                  return product.getVariableItems();
                })
                // If we have successfully obtained an item list.
                .then(function (items) {
                  if (items.length)
                    items.forEach(function (item) {
                      console.log(item.name);
                      console.log(item.type);
                      console.log(item.text);
                      item.text = 'New text';
                    });
                  else
                    console.log('This product contains no variable items.');
                });

              // Getting links to proof images.
              this.editor.getProofImages({ maxHeight: 1000, maxWidth: 1000 })
                // If the links to proof images were generated successfully.
                .then(function (result) {
                  _this.proofImageUrls = result.proofImageUrls;
                  _this.indexOfCurrentSurface = 1;

                  // Get the links from the promise properties.
                  let previewFrame = document.getElementById('previewFrame');
                  var myEmbed = document.createElement('embed');
                  myEmbed.onload = function () {
                    document.getElementById('loaderDiv').className = 'main__iframe';
                  };
                  myEmbed.setAttribute('src', _this.proofImageUrls[_this.indexOfCurrentSurface - 1]);
                  previewFrame.appendChild(myEmbed);

                })
                // If there was an error thrown while getting links to proof images.
                .catch(function (error) {
                  alert(error);
                });
            }
          };
          recaptchaScript.setAttribute('src', `${process.env.VUE_APP_CANVASURL}/Resources/Generated/IframeApi.js`);
          recaptchaScript.async = true;
          recaptchaScript.id = 'CcIframeApiScript';
          document.head.appendChild(recaptchaScript);
        }
      });
  },
  mounted() {
    /*this.$nextTick(() => {
        this.$refs.form.validate();
    });*/
    parent.postMessage('ScrollIntoView', '*');

    const _this = this;
    window.setTimeout(function () {
      _this.$refs.form.validate();
      _this.$refs.orderReference.focus();
    }, 1000);
  },
  watch: {},
  methods: {
    paymentMethodChanged() {
      console.log('here');
      console.log(this.paymentMethod);

      if (this.paymentMethod == 'online') {
        this.cardRequired = true;
      } else {
        this.cardRequired = false;
      }
    },
    navigate(path) {
      Router.push({
        path: '/' + path
      });
    },
    goBack() {
      this.removeCanvasAuthToken(this.canvasAuthToken);

      this.navigate('print-options');
    },
    showConfirmPopup() {
      console.log('showConfirmPopup');

      parent.postMessage('ScrollIntoView', '*');

      this.showConfirmation = true;
    },
    async loadEditor(editorFrame, product, config, templatingValues) {
      var editor = await CustomersCanvas.IframeApi.loadEditor(editorFrame, product, config);

      this.currProd = await editor.getProduct();
      let productModel = await this.currProd.getProductModel();

      productModel.getAllItems().filter(item => item.type === 'BoundedTextItem').forEach(textItem => {
        if (textItem.text.indexOf('[[') > -1) {
          var itemText = textItem.text,
            reg = /[[[a-zA-Z0-9_]*]]/g,
            result;

          // Loop round interpolated placeholders replacing with relevant text from templatingValues
          while ((result = reg.exec(itemText)) !== null) {
            var userVar = result[0].replace('[[', '').replace(']]', '');
            itemText = itemText.replace(result[0], templatingValues[userVar]);
          }

          textItem.text = itemText;
          console.log('textItem.text=' + textItem.text);
          console.log('textItem.originalText=' + textItem.originalText);
        }
      });

      this.currProd.setProductModel(productModel);
      return editor;
    },
    async confirm() {
      this.loading = true;
      console.log('confirm');

      //Export data
      let dataProvider = this.order.dataProvider;

      console.log('dataProvider ', this.order.dataProvider);

      if (dataProvider == 'Databook') {
        await this.exportDatabook(this.order.dataUrl);
      } else {
        await this.exportLeadhub(this.order.dataUrl);
      }

      console.log('this.dataRef=' + this.dataRef);

      if (this.dataRef == '') {
        this.confirmOrderFailure = true;
        return;
      }

      var stateId = window.sessionStorage.getItem('stateId');

      //Patch order with final info
      const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

      const update_body = [
        {
          'value': this.orderReference,
          'path': '/customerRef',
          'op': 'replace'
        },
        {
          'value': this.dataRef,
          'path': '/dataRef',
          'op': 'replace'
        },
        {
          'value': stateId,
          'path': '/templateStateId',
          'op': 'replace'
        },
      ];

      console.log(patch_order);
      console.log(update_body);

      Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response.data);

          const finalise_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/Finalise/` + window.sessionStorage.getItem('_order_id');

          Axios.put(finalise_order, {}, this.returnHeaderUsingToken())
            .then(response => {
              console.log(response);

              //Go to the order confirmation page
              this.navigate('confirmation');
            })
            .catch(error => {
              this.confirmOrderFailure = true;
              this.showConfirmation = false;
              this.confirmOrderFailureData = error.response.data;
            });
        })
        .catch(error => {
          console.log(error);
          this.confirmOrderFailure = true;
        });
    },
    async exportDatabook(qs) {
      console.log('exportDatabook');

      this.query_string = qs;
      if (this.excludes) {
        this.query_string += '&excludes=' + this.excludes;
      }

      this.loading = true;

      // local
      // this.data_url = `http://test.tkv4.co.uk/api/1.1/zpgapi.asp?method=DatabookExport&code=zpg1&customerRef=RAV02`;
      this.data_url = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=DatabookExport&code=zpg1&customerRef=RAV02`;

      console.log('qs=' + this.query_string);
      console.log('endpoint=' + this.data_url);

      await Axios({
        method: 'post',
        url: this.data_url,
        crossdomain: true,
        data: this.query_string,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      })
        .then(response => {
          console.log('export success');

          console.log(response);

          if (response.data.success) {
            this.dataRef = response.data.result;
          } else {
            console.log('export failure: ' + JSON.stringify(response));
            this.dataRef = '';
          }

          this.loading = false;
        })
        .catch(error => {
          if (error.response) {
            console.log('export failure: ' + error.response);
            this.dataRef = '';
          }

          this.loading = false;
        });
    },
    async exportLeadhub(qs) {
      console.log('exportLeadhub');

      this.query_string = qs;
      if (this.excludes) {
        this.query_string += '&excludes=' + this.excludes;
      }

      this.loading = true;

      //let leadhubApiUrl = `${process.env.VUE_APP_LEADHUBAPI}`
      // local
      // let leadhubApiUrl = `http://test.tkv4.co.uk/api/1.1/zpgapi.asp?method=SpectreSearch&code=zpg1&customerRef=RAV02`;

      let leadhubApiUrl = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=SpectreSearch&code=zpg1&customerRef=RAV02`;

      //let data_url = leadhubApiUrl + qs + '&expanded=true';
      let data_url = qs + '&expanded=true';

      if (this.excludes) {
        data_url += '&exclude=' + this.excludes;
      }

      console.log('leadhubApiUrl: ' + leadhubApiUrl);
      console.log('data_url = ' + data_url);

      await Axios({
        method: 'post',
        url: leadhubApiUrl,
        crossdomain: true,
        data: data_url,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      })
        .then(async response => {
          console.log('search success');

          console.log(response.data.attributes);

          var results = response.data.attributes,
            objects = [];

          console.log('results.length=' + results.length);

          for (var i = 0, len = results.length; i < len; i++) {
            console.log(results[i].attributes.primary_address);

            objects.push(results[i].attributes.primary_address);
          }

          console.log(objects);
          let data = JSON.stringify(objects).replace(/\\\"/g, String.fromCharCode(34)).replace(/\"\[/g, '[').replace(/\]\"/g, ']');

          console.log(data);

          // local
          // let export_url = `http://test.tkv4.co.uk/api/1.1/zpgapi.asp?method=SpectreExport&code=zpg1&customerRef=RAV02`;
          let export_url = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=SpectreExport&code=zpg1&customerRef=RAV02`;

          await Axios({
            method: 'post',
            url: export_url,
            crossdomain: true,
            processData: false,
            dataType: 'json',
            data: data,
          })
            .then(response => {
              console.log(response);

              if (response.data.success) {
                this.dataRef = response.data.result.dataRef;
              } else {
                console.log('export failure: ' + JSON.stringify(response));
                this.dataRef = '';
              }

              this.loading = false;
            })
            .catch(error => {
              if (error.response) {
                console.log('export failure: ' + error.response);
                this.dataRef = '';
              }

              this.loading = false;
            });

          this.loading = false;
        })
        .catch(error => {
          if (error.response) {
            console.log('export failure: ' + error.response);
            this.dataRef = '';
          }

          this.loading = false;
        });
    },
    async removeCanvasAuthToken(token) {
      var endpoint = `https://cc.ravensworth.uk/api/Auth/Tokens/` + token;

      await Axios({
        method: 'delete',
        url: endpoint,
        headers: { 'X-CustomersCanvasAPIKey': this.customersCanvasApiKey }
      })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    },

    openCheckout() {
      console.log('openCheckout');

      if (document.getElementById('checkoutScript')) {
        const element = document.getElementById('checkoutScript');

        element.parentNode.removeChild(element);
      }

      if (! document.getElementById('checkoutScript')) {
        const checkoutScript = document.createElement('script');

        checkoutScript.onload = async () => {
          const payButton = document.getElementById('pay-button');
          const form = document.getElementById('payment-form');
          let amount;

          const checkoutInfo = {
            publicKey: `${process.env.VUE_APP_CHECKOUTPKEY}`,
            secretKey: `${process.env.VUE_APP_CHECKOUTSKEY}`,
            channel: `${process.env.VUE_APP_CHECKOUTCHANNEL}`,
            url: `${process.env.VUE_APP_CHECKOUTURL}`,
          };

          console.log('publicKey: '+ checkoutInfo.publicKey);

          Frames.init(checkoutInfo.publicKey);

          const logos = {
            'card-number': {
              src: 'card',
              alt: 'card number logo',
            },
            'expiry-date': {
              src: 'exp-date',
              alt: 'expiry date logo',
            },
            'cvv': {
              src: 'cvv',
              alt: 'cvv logo',
            },
          };

          const errors = {
            'card-number': 'Please enter a valid card number',
            'expiry-date': 'Please enter a valid expiry date',
            'cvv': 'Please enter a valid cvv code',
          };

          const onValidationChanged = (event) => {
            var e = event.element;

            if (event.isValid || event.isEmpty) {
              if (e === 'card-number' && ! event.isEmpty) {
                showPaymentMethodIcon();
              }
              setDefaultIcon(e);
              clearErrorIcon(e);
              clearErrorMessage(e);
            } else {
              if (e === 'card-number') {
                clearPaymentMethodIcon();
              }
              setDefaultErrorIcon(e);
              setErrorIcon(e);
              setErrorMessage(e);
            }
          };

          Frames.removeAllEventHandlers(Frames.Events.FRAME_VALIDATION_CHANGED);
          Frames.addEventHandler(
            Frames.Events.FRAME_VALIDATION_CHANGED,
            onValidationChanged
          );

          const clearErrorMessage = (el) => {
            const message = document.querySelector(`.error-message__${el}`);

            message.textContent = '';
          };

          const clearErrorIcon = (el) => {
            const logo = document.getElementById(`icon-${el}-error`);

            logo.style.removeProperty('display');
          };

          const showPaymentMethodIcon = (parent, pm) => {
            if (parent) {
              parent.classList.add('show');
            }

            const logo = document.getElementById('logo-payment-method');

            if (pm) {
              const name = pm.toLowerCase();

              logo.setAttribute('src', `https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/${name}.svg`);
              logo.setAttribute('alt', pm || 'payment method');
            }

            logo.style.removeProperty('display');
          };

          const clearPaymentMethodIcon = (parent) => {
            if (parent) {
              parent.classList.remove('show');
            }

            const logo = document.getElementById('logo-payment-method');

            logo.style.setProperty('display', 'none');
          };

          const setErrorMessage = (el) => {
            const message = document.querySelector(`.error-message__${el}`);

            message.textContent = errors[el];
          };

          const setDefaultIcon = (el) => {
            const logo = document.getElementById(`icon-${el}`);

            logo.setAttribute('src', `https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/${logos[el].src}.svg`);
            logo.setAttribute('alt', logos[el].alt);
          };

          const setDefaultErrorIcon = (el) => {
            const logo = document.getElementById(`icon-${el}`);

            logo.setAttribute('src', `https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/${logos[el].src}-error.svg`);
            logo.setAttribute('alt', logos[el].alt);
          };

          const setErrorIcon = (el) => {
            const logo = document.getElementById(`icon-${el}-error`);

            logo.style.setProperty('display', 'block');
          };

          const cardValidationChanged = () => {
            payButton.disabled = amount === 0.00
              ? true
              : ! Frames.isCardValid();
          };

          const onCardTokenizationFailed = (error) => {
            console.log('CARD_TOKENIZATION_FAILED: %o', error);
            Frames.enableSubmitForm();
          };

          Frames.removeAllEventHandlers(Frames.Events.CARD_VALIDATION_CHANGED);
          Frames.addEventHandler(
            Frames.Events.CARD_VALIDATION_CHANGED,
            cardValidationChanged
          );

          Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZATION_FAILED);
          Frames.addEventHandler(
            Frames.Events.CARD_TOKENIZATION_FAILED,
            onCardTokenizationFailed
          );

          const onCardTokenized = (event) => {
            if (event.token !== this.token) {
              this.token = event.token;
              //console.log(token);

              var reference = "Order Number: " + this.order.id + ", Branch Code: " + this.order.branchId;

              var paymentDetails = {
                "source": {
                  "type": "token",
                  "token": this.token
                },
                "amount": this.order.grossTotalPrice.toFixed(2)*100,
                "currency": "GBP",
                "processing_channel_id": checkoutInfo.channel,
                "billing_descriptor": {
                  "name": "Ravensworth",
                  "city": "Cramlington"
                },
                "customer": {
                  "email": this.user.emailAddress,
                  "name": this.user.name
                },
                "reference": reference,
                "metadata": {
                  "order_id": this.order.id,
                  "branch_code": this.order.branchId,
                  "system": "Directmailr"
              	}
              }

						  console.log('paymentDetails: ' + JSON.stringify(paymentDetails));

              this.loading = true;

              // local
              // let checkoutPaymentUrl = `http://test.tkv4.co.uk/api/1.1/zpgapi.asp?method=CheckoutPayment&code=zpg1&customerRef=RAV02`;
              let checkoutPaymentUrl = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=CheckoutPayment&code=zpg1&customerRef=RAV02`;

              var http = new XMLHttpRequest
              http.open('POST', checkoutPaymentUrl, true);

              //Send the proper header information along with the request
              http.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

              http.parent = this;
              http.onreadystatechange = async function() {//Call a function when the state changes.
                var _this = this.parent;

                if (http.readyState == 4 && http.status == 200) {
                  console.log(http.responseText);
                  var responseJson = JSON.parse(http.responseText);

                  if (responseJson.status == 'Pending') {//Redirect to merchant 3DS authentication URL
                    window.location.href = responseJson._links.redirect.href;
                  } else {
                    if (responseJson.response_code == '10000') {
                      console.log('Card request APPROVED');

                      //Export data
                      let dataProvider = _this.order.dataProvider;

                      console.log('dataProvider ', _this.order.dataProvider);

                      if (dataProvider == 'Databook') {
                        await _this.exportDatabook(_this.order.dataUrl);
                      } else {
                        await _this.exportLeadhub(_this.order.dataUrl);
                      }

                      console.log('this.dataRef=' + _this.dataRef);

                      if (_this.dataRef == '') {
                        _this.confirmOrderFailure = true;
                        return;
                      }

                      var stateId = window.sessionStorage.getItem('stateId');

                      //Patch order with final info
                      const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

                      const update_body = [
                        {
                          'value': _this.orderReference,
                          'path': '/customerRef',
                          'op': 'replace'
                        },
                        {
                          'value': _this.dataRef,
                          'path': '/dataRef',
                          'op': 'replace'
                        },
                        {
                          'value': stateId,
                          'path': '/templateStateId',
                          'op': 'replace'
                        },
                      ];

                      console.log(patch_order);
                      console.log(update_body);

                      Axios.patch(patch_order, update_body, _this.returnHeaderUsingToken())
                        .then(response => {
                          console.log(response.data);

                          const finalise_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/Finalise/` + window.sessionStorage.getItem('_order_id');

                          Axios.put(finalise_order, {}, _this.returnHeaderUsingToken())
                            .then(response => {
                              console.log(response);

                              //Go to the order confirmation page
                              _this.loading = false;
                              _this.navigate('confirmation');
                            })
                            .catch(error => {
                              _this.confirmOrderFailure = true;
                              _this.showConfirmation = false;
                              _this.loading = false;
                              _this.confirmOrderFailureData = error.response.data;
                            });
                        })
                        .catch(error => {
                          console.log(error);

                          _this.loading = false;
                          _this.confirmOrderFailure = true;
                        });
                    } else {
                      console.log('Card request DECLINED');

                      _this.onClosed();

                      _this.activateMessageDialog = false;
                      _this.paymentErrorDialog = true;
                      _this.paymentErrorMessage = responseJson.response_summary;
                      _this.activateCheckout = false;
                      _this.loading = false;

                      //_this.token = '';

                      console.log(responseJson.response_code);
                      console.log(responseJson.response_summary);
                      Frames.enableSubmitForm();
                    }
                  }
                }
              }

              http.send(JSON.stringify(paymentDetails));
            }
          };

          Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZED);
          Frames.addEventHandler(
            Frames.Events.CARD_TOKENIZED,
            onCardTokenized
          );

          const paymentMethodChanged = (event) => {
            const pm = event.paymentMethod;
            const container = document.querySelector('.icon-container.payment-method');

            if (! pm) {
              clearPaymentMethodIcon(container);
            } else {
              clearErrorIcon('card-number');
              showPaymentMethodIcon(container, pm);
            }
          };

          Frames.removeAllEventHandlers(Frames.Events.PAYMENT_METHOD_CHANGED);
          Frames.addEventHandler(
            Frames.Events.PAYMENT_METHOD_CHANGED,
            paymentMethodChanged
          );

          const onSubmit = (event) => {
            event.preventDefault();
            Frames.submitCard();
          };

          form.addEventListener(
            'submit',
            onSubmit,
          );
        };

        checkoutScript.setAttribute('src', 'https://cdn.checkout.com/js/framesv2.min.js');
        checkoutScript.async = true;
        checkoutScript.id = 'checkoutScript';

        document.head.appendChild(checkoutScript);
      }
    },

    onClosed() {
      Frames.removeAllEventHandlers(Frames.Events.PAYMENT_METHOD_CHANGED);
      Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZED);
      Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZATION_FAILED);
      Frames.removeAllEventHandlers(Frames.Events.CARD_VALIDATION_CHANGED);
      Frames.removeAllEventHandlers(Frames.Events.FRAME_VALIDATION_CHANGED);
    },
  },
};
</script>
